<template>
  <div class="activity">
    <activitylist
      :activityType="activityType"
      :exhibitionType="activeName"
    ></activitylist>
    <statistics></statistics>
  </div>
</template>
<script>
import statistics from '../components/statistics.vue'
export default {
  name: "activity",
  components: {statistics},
  data() {
    return {
      activityType: "活动预约",
      activeName: ""
    };
  },

  methods: {
    getQueryStringRegExp: function getQueryStringRegExp (name) {
      var reg = new RegExp("(^|\\?|&)" + name + "=([^&]*)(\\s|&|$)", "i");
      if (reg.test(location.href))
        return unescape(RegExp.$2.replace(/\+/g, " "));
      return "";
    }
  },

  created() {
    this.$store.state.museumCode = this.getQueryStringRegExp('museumCode')
  }
};
</script>
<style lang="scss" scoped>
.activity {
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/activity.vue